import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
import { AddmodifiertypeComponent } from '../../modifiertype/addmodifiertype/addmodifiertype.component';
import * as glb from '../../../services/constants/global'

@Component({
  selector: 'app-addmodifier',
  templateUrl: './addmodifier.component.html',
  styleUrls: ['./addmodifier.component.css']
})
export class AddmodifierComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  ismodifiertypeaddmode: boolean = false;

  pricetypeColl: any = [];
  modifiertypeColl: any = [];
  //Edit Get Values
  modifierColl: any = [];
  modifierid: number = 0

  taxColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  modifierform = new FormGroup({
    modifierid: new FormControl(0),
    modifiername: new FormControl('', Validators.required),
    modifiertypeid: new FormControl(null, Validators.required),
    modifierprice: new FormControl(null),
    istaxincluded: new FormControl(false),
    taxid: new FormControl(null),
    sp1: new FormControl(null),
    sp2: new FormControl(null),
    sp3: new FormControl(null),
    sp4: new FormControl(null),
    sp5: new FormControl(null),
    sp6: new FormControl(null),
    sp7: new FormControl(null),
    sp8: new FormControl(null),
    sp9: new FormControl(null),
    sp10: new FormControl(null),
    inactive: new FormControl(false),
  });


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Modifier";


  @Input() modifiername: any = '';
  @Output() emitData = new EventEmitter();

  issp1: boolean = false;
  issp2: boolean = false;
  issp3: boolean = false;
  issp4: boolean = false;
  issp5: boolean = false;
  issp6: boolean = false;
  issp7: boolean = false;
  issp8: boolean = false;
  issp9: boolean = false;
  issp10: boolean = false;


  sp1displayname: string = '';
  sp2displayname: string = '';
  sp3displayname: string = '';
  sp4displayname: string = '';
  sp5displayname: string = '';
  sp6displayname: string = '';
  sp7displayname: string = '';
  sp8displayname: string = '';
  sp9displayname: string = '';
  sp10displayname: string = '';

  currencyMask:any=glb.GlobalSettings.maskValue;
  
  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, private productFindService: NgbModal,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.modifierid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.modifierform.reset();
      this.fnInitializeModifier();

      if (this.modifierid > 0) {
        this.fngetModifier();
      }
      this.fngetPricetype()
      this.fngetModifiertype();
      this.fngetTax();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.modifierid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.ismodifiertypeaddmode = this.loginService.fnCheckUserRoleAction("Modifiertype", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeModifier() {
    this.modifierform.setValue({

      modifierid: 0,
      modifiername: '',
      modifiertypeid: '',
      modifierprice: null,
      istaxincluded:false,
      taxid: null,
      sp1: null,
      sp2: null,
      sp3: null,
      sp4: null,
      sp5: null,
      sp6: null,
      sp7: null,
      sp8: null,
      sp9: null,
      sp10: null,
      inactive: false,
    })
  }

  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;



            for (let abo of this.pricetypeColl) {
              if (abo.pricetag === 'SP1') {
                this.issp1 = true
                this.sp1displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP2') {
                this.issp2 = true
                this.sp2displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP3') {
                this.issp3 = true
                this.sp3displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP4') {
                this.issp4 = true
                this.sp4displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP5') {
                this.issp5 = true
                this.sp5displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP6') {
                this.issp6 = true
                this.sp6displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP7') {
                this.issp7 = true
                this.sp7displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP8') {
                this.issp8 = true
                this.sp8displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP9') {
                this.issp9 = true
                this.sp9displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP10') {
                this.issp10 = true
                this.sp10displayname = abo.pricetypename
              }
            }

          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetTax() {

    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetModifiertype() {

    var data = {
      'modifiertypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getModifiertype(data)
      .subscribe(
        (res) => {
          this.modifiertypeColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetModifier() {

    var data = {
      'modifierid': this.modifierid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getModifier(data)
      .subscribe(
        (res) => {
          this.modifierColl = res.json().result;
          var editdata = this.modifierColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.modifierform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'modifierid': this.modifierid,
          'modifiername': this.modifierform.get('modifiername').value,
          'modifiertypeid': this.modifierform.get('modifiertypeid').value,
          'taxid': this.modifierform.get('taxid').value,
          'modifierprice': this.modifierform.get('modifierprice').value,
          'istaxincluded': this.modifierform.get('istaxincluded').value,          
          'sp1': this.modifierform.get('sp1').value,
          'sp2': this.modifierform.get('sp2').value,
          'sp3': this.modifierform.get('sp3').value,
          'sp4': this.modifierform.get('sp4').value,
          'sp5': this.modifierform.get('sp5').value,
          'sp6': this.modifierform.get('sp6').value,
          'sp7': this.modifierform.get('sp7').value,
          'sp8': this.modifierform.get('sp8').value,
          'sp9': this.modifierform.get('sp9').value,
          'sp10': this.modifierform.get('sp10').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.modifierform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckModifier(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.modifierform.get('modifierid').value > 0) {
                //Update Department
                this.fnSetModifier(data);
              }
              else {
                //Insert Department
                this.fnInsertModifier(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;

                this.modifierform.controls['modifiername'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertModifier(data) {

    this.appService.fnInsertModifier(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The new Modifier has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.modifierid);

          this.emitData.emit(this.modifierid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetModifier(data) {

    this.appService.fnSetModifier(data).subscribe(
      (res) => {
        this.saveloading = false;
console.log(res.json())
        if (res.json().result != "") {
          this.toastr.success('', "The Modifier has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.modifierid, data.modifiername);

          this.emitData.emit(this.modifierid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  private fnAddModifierType() {

    const modalRef = this.productFindService.open(AddmodifiertypeComponent, { size: <any>'m' });
    modalRef.componentInstance.modifiertypeColl = this.modifiertypeColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetModifiertype();

      if (receivedEntry > 0) {
        this.modifierform.patchValue({ modifiertypeid: receivedEntry })
      }
    });

  }


  private fnEditMode(deptBO) {

    this.modifierform.setValue({

      modifierid: deptBO.modifierid,
      modifiername: deptBO.modifiername,
      modifiertypeid: deptBO.modifiertypeid,
      taxid: deptBO.taxid,
      modifierprice: deptBO.modifierprice,
      istaxincluded: deptBO.istaxincluded,
      sp1: deptBO.sp1,
      sp2: deptBO.sp2,
      sp3: deptBO.sp3,
      sp4: deptBO.sp4,
      sp5: deptBO.sp5,
      sp6: deptBO.sp6,
      sp7: deptBO.sp7,
      sp8: deptBO.sp8,
      sp9: deptBO.sp9,
      sp10: deptBO.sp10,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
